export * from "./masterpass";
export * from "./mobilepay";
export * from "./test";
export * from "./vipps";



// WEBPACK FOOTER //
// ./src/clients/index.ts